// extracted by mini-css-extract-plugin
export default {"cls1":"AdminBarActivator-cls1_zh3","cls2":"AdminBarActivator-cls2__4L AdminBarActivator-cls1_zh3"};